import { Icon, MiniLoader, PageTitle } from '@pwc/pwc-deals-ui';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import ModalConfirmation from 'common/components/ModalConfirmation';
import {
  getIngestedDocuments,
  getStructuredAnalysisErrors,
  getSuccessfullyIngestedDocumentTimes,
} from 'common/engine/reducers/StructuredAnalysisSlice';
import {
  getStructuredAnalysisViewDocumentsWithContent,
  getStructuredAnalysisViewLoadingInProcess,
  startProcessing,
} from 'common/engine/reducers/structuredAnalysisViewSlice';
// eslint-disable-next-line import/extensions
import { getErrorMessageWithLink } from 'common/helpers/duplicateTitleError';
import { clearDataAndTransformAllIngestedStructuredDocumentsThunk } from 'common/engine/thunks/clearDataAndtransformAllIngestedStructuredDocumentsThunk';
import LoadingError from 'common/components/LoadingError';
import {
  getProjectSharePointUrl,
  getDocumentPath,
  getProjectSource,
} from 'features/project/projectSlice';
import { projectsContentsSearch } from '../../analysesService';
import { intersect } from '../../common/utils';
import '../AddAnalysisType.scss';
import IngestStructuredAnalysisButton from '../../structured-analysis/IngestStructuredAnalysisButton/IngestStructuredDocumentButton';
import {
  getStructuredAnalysesDocuments,
  getStructuredAnalysesDocumentsSelector,
} from '../../getStructuredAnalysesDocumentsSlice';

export const StructuredV1 = () => {
  const { projectId } = useParams();
  const sharepointUrl = useSelector(getProjectSharePointUrl);
  const documentPath = useSelector(getDocumentPath);
  const projectSource = useSelector(getProjectSource);
  const sharePointJuntion = `//${sharepointUrl}/Shared%20Documents/Forms/AllItems.aspx`;
  const sharePointId = sharepointUrl?.substr(sharepointUrl?.indexOf('/'));
  const [duplicatedAnalysis, setDuplicatedAnalysis] = useState({});

  const errorMessages = useSelector(getStructuredAnalysisErrors);
  const ingestedDocuments = useSelector(getIngestedDocuments);
  const successfullyIngestedDocumentTimes = useSelector(
    getSuccessfullyIngestedDocumentTimes
  );
  const [isFetching, setIsFetching] = useState(false);
  const { loading, error, structuredDocuments } = useSelector(
    getStructuredAnalysesDocumentsSelector
  );

  const [isRaceErrorVisible, setRaceError] = useState(false);

  const { i18n } = useTranslation();
  useEffect(() => {
    moment.locale(i18n.language === 'jp' ? 'ja' : 'en');
  }, [i18n.language]);

  const cards = [
    {
      name: 'Quality of Earnings',
      codes: ['PandL', 'QofE'],
      route: 'quality-of-earnings',
      contentSubType: Constants.structuredDocumentSubtypeCodes.QofE,
    },
    {
      name: 'Net Working Capital',
      codes: ['BsV', 'NWC'],
      route: 'net-working-capital',
      contentSubType: Constants.structuredDocumentSubtypeCodes.NWC,
    },
    {
      name: 'Debt and Debt Like',
      codes: ['DDL'],
      route: 'debt-debt-like',
      contentSubType: Constants.structuredDocumentSubtypeCodes.DDL,
    },
  ];

  const existingAnalyses = useSelector(
    getStructuredAnalysisViewDocumentsWithContent
  );

  const loadingInProcess = useSelector(
    getStructuredAnalysisViewLoadingInProcess
  );

  const [allStructuredIngestionDocuments, setAllStructuredIngestionDocuments] =
    useState([]);

  const dispatch = useDispatch();
  const fetchAnalysis = async (documentCodes) => {
    await dispatch(
      clearDataAndTransformAllIngestedStructuredDocumentsThunk(
        projectId,
        documentCodes,
        false
      )
    );
  };
  let sharePointLink = sharePointJuntion;

  if (documentPath) {
    sharePointLink =
      projectSource === 'Junction' || projectSource === 'DTP'
        ? sharePointJuntion
        : `${sharePointJuntion}?id=${sharePointId}/Shared%20Documents${documentPath}`;
  }

  /**
   * To control if exist item with default SA titles.
   */
  const checkDuplicates = async () => {
    const checks = [];
    const titles = [];

    for (let i = 0; i < cards.length; i += 1) {
      const { name: title } = cards[i];
      checks.push(
        projectsContentsSearch(projectId, {
          title,
        })
      );
      titles.push(title.toLowerCase());
    }
    const matchingItemsSAWithDefaultTitle = await Promise.all(checks);

    const allowedSA = matchingItemsSAWithDefaultTitle
      .map((matchingItems) => {
        let foundDuplicity = null;
        if (matchingItems) {
          foundDuplicity = matchingItems.find(
            (el) =>
              titles.includes(el.title.toLowerCase()) &&
              ![
                Constants.structuredDocumentSubtypeCodes.DDL,
                Constants.structuredDocumentSubtypeCodes.NWC,
                Constants.structuredDocumentSubtypeCodes.QofE,
              ].includes(el.contentSubType)
          );
        }
        return (
          foundDuplicity && {
            [foundDuplicity.title.toLowerCase()]: foundDuplicity,
          }
        );
      })
      .filter(Boolean);

    setDuplicatedAnalysis(
      !isEmpty(allowedSA) ? Object.assign(...allowedSA) : {}
    );
  };

  useEffect(() => {
    dispatch(startProcessing());
    try {
      dispatch(getStructuredAnalysesDocuments(projectId));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetch = async () => {
      const codes = cards.reduce((acc, card) => {
        card.codes.map((code) => acc.push(code));
        return acc;
      }, []);
      await checkDuplicates();
      await fetchAnalysis(codes);
      setAllStructuredIngestionDocuments(structuredDocuments);
    };
    if (!isFetching && structuredDocuments.length > 0) {
      setIsFetching(true);
      fetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cards, structuredDocuments]);

  return (
    <>
      <ModalConfirmation
        show={isRaceErrorVisible}
        showCancel={false}
        onCancel={() => setRaceError(false)}
        onConfirm={() => window.location.reload()}
        confirmTitle="Unable to add a Structured Analysis as it has already created."
        confirmationMessage="Please refresh the page or try again later."
        confirmButtonText="Refresh page"
        dialogClassName="modal-confirmation"
        contentClassName="modal-confirmation"
      />

      {error ? (
        <LoadingError />
      ) : (
        <section className="template-analysis-section">
          <PageTitle title="Template" size="h2" />

          <p>
            Create common analyses by importing data directly from your
            templated{' '}
            <a
              className="external-source-link"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sharepoint-link"
              href={sharePointLink}
            >
              Sharepoint
            </a>{' '}
            files. Remember to populate them before importing their data to
            Junction.
          </p>

          <div className="card-container2">
            {cards.map((card) => {
              const titleDuplicateExist = Object.keys(
                duplicatedAnalysis
              ).includes(card.name.toLowerCase());
              const duplicityTypeAndLink = titleDuplicateExist
                ? getErrorMessageWithLink(
                    duplicatedAnalysis[card.name.toLowerCase()],
                    projectId
                  )
                : {};
              const intersectedWithDocuments =
                intersect(ingestedDocuments, card.codes).length ===
                card.codes.length;
              const intesectedWithAnalysis =
                intersect(
                  existingAnalyses.map((x) => x.code),
                  card.codes
                ).length === card.codes.length;

              const ingestedCardDocs =
                intersectedWithDocuments || intesectedWithAnalysis;

              const existingSAdocument = existingAnalyses.find(
                (doc) => doc?.content?.contentSubType === card.contentSubType
              );

              if (loading || loadingInProcess) {
                return (
                  <div className="card2" key={card.name}>
                    <div
                      style={{
                        display: 'flex',
                        gap: 5,
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <MiniLoader />
                    </div>
                  </div>
                );
              }

              let analysis;
              return (
                <div className="card2" key={card.name}>
                  <div className="container">
                    {titleDuplicateExist && !existingSAdocument && (
                      <Icon
                        name="alert"
                        width={20}
                        height={32}
                        data-testid={`${card.codes[0]}-alert-title`}
                        className="form-error-msg__icon"
                      />
                    )}
                    <PageTitle
                      title={existingSAdocument?.content?.title || card.name}
                      size="h3"
                    />
                  </div>
                  {titleDuplicateExist && !existingSAdocument && (
                    <div
                      className="duplicate-info"
                      data-testid={`${card.codes[0]}-duplicate-message`}
                    >
                      A {duplicityTypeAndLink.type} with this title already
                      exists. Please rename the existing &apos;
                      <Link
                        className="external-source-link"
                        to={duplicityTypeAndLink.linkTo}
                      >
                        {card.name}
                      </Link>
                      &apos;, before adding this template analysis.
                    </div>
                  )}
                  <div>
                    {(!titleDuplicateExist || existingSAdocument) &&
                      allStructuredIngestionDocuments
                        .filter((doc) => card.codes.includes(doc.code))
                        .map((doc, index) => {
                          analysis = existingAnalyses.find(
                            (x) => x.code === doc.code
                          );
                          const dateModified = analysis
                            ? analysis.dateModified
                            : null;
                          const ingestionTime =
                            successfullyIngestedDocumentTimes[doc.code] ||
                            dateModified;
                          const errorMessage = errorMessages[doc.code];

                          const ingestionTimeMoment = moment(ingestionTime);

                          const ingested = ingestedCardDocs || analysis;

                          return (
                            <div
                              className="external-source-links2"
                              key={doc.code}
                            >
                              {`${index + 1}. `}&nbsp;
                              <a
                                className="external-source-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="project-sharepoint-link"
                                href={doc.sharePointItemUrl}
                              >
                                {doc.workbookName}
                              </a>
                              {ingested &&
                                ingestionTime &&
                                intesectedWithAnalysis && (
                                  // Imported at 17:15 GMT+1 - 20 May 2021
                                  <div className="status-container">
                                    <Icon
                                      name="check"
                                      data-testid={`${card.codes[0]}-confirm-icon`}
                                      width={16}
                                      className="fill icon-green"
                                    />
                                    <div
                                      data-testid={`${card.codes[0]}-no-link`}
                                    >
                                      Imported at{' '}
                                      {`${ingestionTimeMoment.format(
                                        'HH:mm Z - D MMM YYYY'
                                      )}`}
                                    </div>
                                  </div>
                                )}
                              {errorMessage && (
                                <div className="status-container">
                                  <Icon
                                    name="alert"
                                    data-testid={`${card.codes[0]}-alert-icon`}
                                    width={14}
                                    className="fill icon-red-error"
                                  />
                                  <div
                                    data-testid={`${card.codes[0]}-no-link`}
                                    className="import-error"
                                  >
                                    This item cannot be imported because it
                                    contains errors.
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                    {!loadingInProcess && !analysis && (
                      <IngestStructuredAnalysisButton
                        documentCodes={card.codes}
                        disabled={titleDuplicateExist}
                        route={card.route}
                        projectId={projectId}
                      />
                    )}
                    {!loadingInProcess && analysis && (
                      <span>
                        Analyses already created:{' '}
                        <Link
                          className="external-source-link"
                          to={`/projects/${projectId}/analyses/${card.route}`}
                        >
                          {existingSAdocument?.content?.title || card.name}
                        </Link>
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      )}
    </>
  );
};
